import { Post } from '@/types/redux/kol-content'
import { PlatformType } from '@/utils/convert-platform'
import { getContentImageUrlFromApiServer } from '@/utils/post/get-image-url-from-api-server'

const getPostThumbnailUrls = (
  post: Pick<
    Post,
    'platformType' | 'crawledID' | 'postID' | 'igPostId' | 'thumbnail'
  >,
): string[] => {
  return [
    post.platformType === PlatformType.YouTube
      ? `https://img.youtube.com/vi/${post.postID}/hqdefault.jpg`
      : post.thumbnail,
    getContentImageUrlFromApiServer(post),
  ]
}

export default getPostThumbnailUrls
